import script from "./news.vue?vue&type=script&setup=true&lang=js"
export * from "./news.vue?vue&type=script&setup=true&lang=js"

import "./news.vue?vue&type=style&index=0&id=bc4b8618&lang=less&scoped=true"

import exportComponent from "D:\\WorkSpace\\girard\\girard-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bc4b8618"]])

export default __exports__